<ion-header class="header --w-back-button">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-list class="breadcrumb">
        <ion-item
          *ngFor="let breadcrumb of breadcrumbs"
          class="breadcrumb__item"
          detail="false"
          routerDirection="back"
          [routerLink]="[breadcrumb.link]"
        >
          <span [innerHTML]="breadcrumb.name"></span> <span class="breadcrumb__item__dash">/</span>
        </ion-item>
      </ion-list>
      <ion-back-button
        [defaultHref]="routes.reports + '/' + slug + '/' + routes.history"
        text=""
        icon="arrow-back-outline"
      ></ion-back-button>
    </ion-buttons>
    <ion-title>
      <span [innerHTML]="i18nKey + '.BREADCRUMB_NAME' | translate"></span>
    </ion-title>
    <ion-buttons slot="end">
      <ion-menu-button class="header__burger" icon="menu-outline" autoHide="false"></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="report" [fullscreen]="true">
  <app-survey [slug]="slug" [month]="+(month$ | async)" [year]="+(year$ | async)"></app-survey>
</ion-content>

<ion-footer class="footer">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button
        class="button --text --dark --is-summary --text-logo"
        [innerHTML]="'SURVEYS.SUMMARY' | translate: { current: ((reports$ | async) | reportsWithQuestion:(fields$ | async))?.length, total: (fields$ | async)?.length }"
      ></ion-button>

      <label
        for="progress"
        class="survey__label"
        [innerHTML]="i18nKey + '.PROGRESS_LABEL' | translate:{ done: ((reports$ | async) | reportsWithQuestion:(fields$ | async))?.length, total: (fields$ | async)?.length }"
      ></label>
      <progress id="progress" class="survey__progress" [max]="(fields$ | async)?.length" [value]="(reports$ | async)?.length"></progress>
    </ion-buttons>

    <ion-buttons slot="end">
      <ion-button
        class="button --big --primary"
        [class.--greyed-out]="!((fields$ | async) | isValidReport:(reports$ | async))"
        (click)="storeResponses()"
      >
        <ion-spinner *ngIf="loading$ | async; else text"></ion-spinner>
        <ng-template #text><ion-text [innerHTML]="i18nKey + '.SEND' | translate"></ion-text></ng-template>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
